import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("viewna_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const apiViewer = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

apiViewer.interceptors.request.use((config) => {
  const token = localStorage.getItem("viewna_viewer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
